import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { PostClubProfileHousingParams } from '@/shared/api/requests/club/housing/post/request';
import { postClubProfileHousing } from '@/shared/api/requests/club/housing/post/request';

export const useClubProfileHousingMutation = (
  settings?: MutationSettings<
    PostClubProfileHousingParams,
    typeof postClubProfileHousing
  >
) =>
  useMutation({
    mutationKey: ['ClubProfileHousing'],
    mutationFn: ({ params, config }) =>
      postClubProfileHousing({
        params,
        config
      }),
    ...settings?.options
  });
